import React, { useState } from 'react';
import RModal from '../../../../components/Rsuite/Modal';
import api from '../../../../services/api';
import { CustomButton } from '../../../../components/CustomButton';
import { Item } from './Item';
import { useCallback } from 'react';

export function EditSequence({
  open,
  onClose,
  montagensProduto,
  handleMontagensProduto,
}) {
  const [isLoading, setIsLoading] = useState(false);

  async function handleSaveSequence() {
    try {
      setIsLoading(true);
      const montagensSequencePromise = montagensProduto.map((mont, index) =>
        api.patch(`/produto-montagens/alterar/${mont.Id}`, {
          Sequencia: index + 1,
        }),
      );

      await Promise.all(montagensSequencePromise);

      onClose();
      setIsLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  }

  const moveCard = useCallback(
    (dragIndex, hoverIndex) => {
      const newItems = Array.from(montagensProduto);
      const [reorderedItem] = newItems.splice(dragIndex, 1);
      newItems.splice(hoverIndex, 0, reorderedItem);

      handleMontagensProduto(newItems);
    },
    [montagensProduto],
  );

  return (
    <RModal
      open={open}
      onClose={onClose}
      title="Editar Sequencia"
      footer={
        <CustomButton onClick={handleSaveSequence} disabled={isLoading}>
          Salvar
        </CustomButton>
      }
    >
      {montagensProduto.map((montagem, index) => (
        <Item
          key={montagem.Id}
          montagem={montagem}
          index={index}
          moveCard={moveCard}
        />
      ))}
    </RModal>
  );
}
